import React, { useState } from 'react';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function formatCurrency(amount) {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);
}

function truncateHash(hash) {
  if (!hash) return '—';
  if (hash.length <= 12) return hash;
  return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
}

export default function PaymentRow({ payment }) {
  const [copied, setCopied] = useState(false);

  // Backend returns transactionHash (not txHash), paymentDate (not paidAt)
  const txHash = payment.transactionHash || payment.txHash;
  const paidDate = payment.paymentDate || payment.paidAt;
  // web2 payments carry a PayPal reference instead of a transaction hash
  const copyValue = txHash || payment.paymentReference;

  const handleCopy = () => {
    if (!copyValue) return;
    navigator.clipboard.writeText(copyValue).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="pay-item">
      <div className="pay-campaign" data-label="Campaign">{payment.campaignName}</div>
      <div
        className="pay-amount"
        data-label="Amount"
        style={payment.status === 'paid' ? { color: 'var(--gold)' } : undefined}
      >
        {formatCurrency(payment.amount)}
      </div>
      <div data-label="Status">
        <span className={`pay-status ${payment.status}`}>{payment.status}</span>
      </div>
      <div className="pay-date" data-label={payment.status === 'paid' ? 'Date' : 'Expected'}>
        {payment.status === 'paid' ? formatDate(paidDate) : payment.dateLabel || '—'}
      </div>
      <div data-label="Transaction">
        {payment.confirmationLink ? (
          <a
            className="pay-hash"
            href={payment.confirmationLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            View confirmation
          </a>
        ) : copyValue && (
          <button
            className="pay-hash"
            onClick={handleCopy}
            style={copied ? { color: 'var(--gold)' } : undefined}
          >
            {copied ? 'Copied' : truncateHash(copyValue)}
          </button>
        )}
      </div>
    </div>
  );
}
